import OrganisationIndexGroupMapper from "../service/OrganisationIndexGroupMapper";
import OrganisationIndexGroupParamMapper from "../service/OrganisationIndexGroupParamMapper";
import GetResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";

export default class FindConnectedIndexGroupsInteractor {
  private resource: GetResourceEntriesInteractor<IOrganisationIndexGroup>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(groupId: number, organisationId: number) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${organisationId}/groups/organisation/connected`,
      OrganisationIndexGroupMapper,
      OrganisationIndexGroupParamMapper,
      {
        params: { groupId: groupId }
      }
    );
  }
}
